module.exports = __webpack_public_path__ + "img/sway-logo-white-v2.61f21709.png";